export enum DocumentCodes {
  ORDER = '01',
  PRODUCTION_ORDER = '02',
  DELIVERY_NOTE = '03',
  EXPORT = '04',
  BATCH_OPEN_ORDERS_DOCUMENT = '05',
  LABEL = '06',
  STOCK_TRANSFER = '10'
}
